export enum TicketType {
    XOLA = "xola",
    VOUCHER = "voucher",
    OTA = "ota",
    AFFILIATE = "affiliate",
}

export interface Ticket {
    type: TicketType;
    code?: string;
}
